// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/picker/style/index.less
// module id = 164
// module chunks = 0